<template>
  <div>
    <header id="header">
      <div class="h-title">{{ navTitle }}</div>
      <div class="btn-left">
        <button type="" class="btn-pre" @click="goBack">
          <div class="icon icons-left"></div>
        </button>
      </div>

      <div class="btn-right">
        <button
          type=""
          class="btn-support"
          @click="clickBtnCON"
          v-if="isHeaderConBtn == true"
        >
          <div class="icon icons-support"></div>
        </button>

        <button type="" class="btn-home" @click="clickBtnHome">
          <div class="icon icons-home"></div>
        </button>
      </div>
    </header>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Modal_SelectConType from "@/components/popup/Modal_SelectConType.vue";
import Modal_SelectConTp09000 from "@/components/popup/Modal_SelectConTp09000.vue";
import Modal_WaitInfo from "@/components/popup/Modal_WaitInfo.vue";
export default {
  computed: {
    ...mapState("manageUI", {
      navTitle: state => state.navTitle,
      isHeaderConBtn: state => state.isHeaderConBtn
    }),
    isBizTime() {
      return this.checkBizTime();
    }
  },
  methods: {
    goBack() {
      //this.$router.go(-1)
      //comApi.goBack();
      this.$goBack();
    },
    clickBtnCON() {
      //상담사연결 요청
      if (this.isBizTime) {
        //영업시간인 경우
        const pgmObj = this.getProgramData();

        if (!this.$Util.isEmpty(pgmObj)) {
          if (pgmObj.pgm_skl_cd.indexOf(",") > 0) {
            if (pgmObj.pgm_id == "VARS09000") {
              const name = `modal-alert-selectcontp09000`;
              this.$modal.show(
                Modal_SelectConTp09000,
                { pgmobj: pgmObj },
                {
                  name,
                  width: "85%",
                  height: "auto",
                  styles: { "border-radius": "9px" }
                },
                { "before-close": this.closeSelConTpEvent }
              );
            } else {
              //본인인증화면
              const name = `modal-alert-selectcontype`;
              this.$modal.show(
                Modal_SelectConType,
                { pgmobj: pgmObj },
                {
                  name,
                  width: "85%",
                  height: "auto",
                  styles: { "border-radius": "9px" }
                },
                { "before-close": this.closeSelConTpEvent }
              );
            }
          } else {
            //스킬코드가 1개일 경우
            //const isAuthzYn = this.$store.getters["customer/isAuthorize"];

            // 인증에 실패하더라도 인증 시도가 있었다면 본인확인 절차 생략(2023.02.16)
            const isTryAuth = this.$store.getters["customer/isTryAuth"];
            const connCustNo = this.$store.getters["customer/getConnInfo"](
              "custNo"
            );
            const selfConfirmInfo = this.$store.getters["customer/getSelfConfirmInfo"];
            
            //console.log("여기!!!")

            this.log_debug("접속 고객번호 : " + connCustNo);
            var AuthUser = this.$store.getters["user"];
            this.log_debug("인증 고객번호 : " + AuthUser);

            this.log_debug("인증 시도 유무 : " + isTryAuth + ", 본인확인 정보 : " + selfConfirmInfo);
            // 인증이 안되고, 본인확인이 안된 사용자는 무조건 본인확인을 태운다.
            this.$Util.setStore("CONN_VDN_CD", pgmObj.pgm_vdn_cd);
            this.$Util.setStore("CONN_SKL_CD", pgmObj.pgm_skl_cd);
            this.$Util.setStore("CONN_SVC_CD", this.$route.name);
            this.$Util.setStore("CBT_PRT_YN", pgmObj.cbt_prt_yn);
            this.$Util.setStore("CHAT_SPRT_BIZ_YN", pgmObj.chat_sprt_biz_yn);

            if (! isTryAuth && ! this.$Util.isEmpty(connCustNo) && selfConfirmInfo == null) {
              this.$go("VARS00600");
              return false;
            }

            if (isTryAuth || !this.$Util.isEmpty(connCustNo) || !this.$Util.isEmpty(selfConfirmInfo)) {
              this.log_debug("인증된 사용자 이다.");
              let params = { vdn_cd: pgmObj.pgm_vdn_cd };
              const name = `modal-alert-waitinfo`;

              // ERS서버 다운 여부를 store에서 조회. 다운되어도 상담사 연결 팝업은 열려야 함(2022.08.03)
              let isAliveERS = this.$store.getters["system/getIsAliveERS"];
              if (isAliveERS) {
                this.$syncPost("/api/IE/reqERSCustCnt", params).then(
                  response => {
                    let res = response.data;
                    //res.data.watingCnt = 22;
                    //res.data.watingTime = 200;
                    this.$modal.show(
                      Modal_WaitInfo,
                      {
                        count: res.data.watingCnt,
                        wating: res.data.watingTime,
                        skl_cd: pgmObj.pgm_skl_cd
                      },
                      {
                        name,
                        width: "85%",
                        height: "auto",
                        styles: { "border-radius": "9px" }
                      },
                      { "before-close": this.closeWaitInfoEvent }
                    );
                  }
                );
              } else {
                this.$modal.show(
                  Modal_WaitInfo,
                  {
                    count: null,
                    wating: null,
                    skl_cd: pgmObj.pgm_skl_cd
                  },
                  {
                    name,
                    width: "85%",
                    height: "auto",
                    styles: { "border-radius": "9px" }
                  },
                  { "before-close": this.closeWaitInfoEvent }
                );
              }
            } else {
              this.log_debug("사용이용자 확인! - 인증안된 사용자이다.");
              let params = {
                vdn_cd: pgmObj.pgm_vdn_cd,
                skl_cd: pgmObj.pgm_skl_cd,
                svcCode: this.$route.name
              };
              this.$Util.setStore("CONN_VDN_CD", pgmObj.pgm_vdn_cd);
              this.$Util.setStore("CONN_SKL_CD", pgmObj.pgm_skl_cd);
              this.$Util.setStore("CONN_SVC_CD", this.$route.name);
              this.$Util.setStore("CBT_PRT_YN", pgmObj.cbt_prt_yn);
              this.$Util.setStore("CHAT_SPRT_BIZ_YN", pgmObj.chat_sprt_biz_yn);

              this.$go("VARS00500", params);
            }
          }
        }
      } else {
        let clbk_yn = this.$store.getters["customer/getConnInfo"]("clbk_yn");

        if (clbk_yn == "N") {
          this.$alert({
            contents:
              "지금은 상담가능한 시간이 아닙니다.<BR />상담가능한 시간은 평일 오전 9시부터 오후 6시까지입니다.",
            btn_type: this.$CONST.BTN_TP_OK
          });
        } else {
          this.$alert({
            contents:
              "지금은 상담가능한 시간이 아닙니다.<BR />상담가능한 시간은 평일 오전 9시부터 오후 6시까지입니다.<BR /><BR />전화번호를 남기시면,<BR />다음 상담가능 시간에 연락드리겠습니다.",
            btn_type: this.$CONST.BTN_TP_CUSTOM,
            buttons: [
              {
                title: "닫기",
                class: "btn-default"
              },
              {
                title: "전화번호 남기기",
                class: "btn-primary",
                default: true
              }
            ]
          })
            .then(btnIndex => {
              //서비스종료
              if (btnIndex == 1) {
                this.$go("VARS00400");
              }
            })
            .catch(function(err) {
              this.log_error(err);
            });
        }
      }
    },
    closeSelConTpEvent(event) {
      //타입선택 팝업 종료시 이벤트
      if (!this.$Util.isEmpty(event.params)) {
        const pgmObj = this.getProgramData();

        let arrVdnCd = pgmObj.pgm_vdn_cd.split(",");
        let selIndex = event.params;

        //스킬코드가 1개일 경우
        //const isAuthzYn = this.$store.getters["customer/isAuthorize"];
        
        // 인증에 실패하더라도 인증 시도가 있었다면 본인확인 절차 생략(2023.02.16)
        const isTryAuth = this.$store.getters["customer/isTryAuth"];
        const connCustNo = this.$store.getters["customer/getConnInfo"](
          "custNo"
        );
        const selfConfirmInfo = this.$store.getters["customer/getSelfConfirmInfo"];
        this.log_debug("접속 고객번호!! : " + connCustNo);

        let arrSklCd = pgmObj.pgm_skl_cd.split(",");
        this.log_debug("인증 시도 유무 : " + isTryAuth + ", 본인확인 정보 : " + selfConfirmInfo);
        // 인증이 안되고, 본인확인이 안된 사용자는 무조건 본인확인을 태운다.
        if (! isTryAuth && ! this.$Util.isEmpty(connCustNo) && selfConfirmInfo == null) {
          this.$go("VARS00600");
          return false;
        }

        if (isTryAuth || !this.$Util.isEmpty(connCustNo) || !this.$Util.isEmpty(selfConfirmInfo)) {
          //인증 사용자 일경우
          let params = { vdn_cd: arrVdnCd[selIndex] };
          const name = `modal-alert-waitinfo`;

          // ERS서버 다운 여부를 store에서 조회. 다운되어도 상담사 연결 팝업은 열려야 함(2022.08.03)
          let isAliveERS = this.$store.getters["system/getIsAliveERS"];
          if (isAliveERS) {
            this.$syncPost("/api/IE/reqERSCustCnt", params).then(response => {
              let res = response.data;
              //res.data.watingCnt = 33;
              //res.data.watingTime = 330;
              //대기인원수 파악
              this.$modal.show(
                Modal_WaitInfo,
                {
                  count: res.data.watingCnt,
                  wating: res.data.watingTime,
                  skl_cd: arrSklCd[selIndex]
                },
                {
                  name,
                  width: "85%",
                  height: "auto",
                  styles: { "border-radius": "9px" }
                },
                { "before-close": this.closeWaitInfoEvent }
              );
            });
          } else {
            this.$modal.show(
              Modal_WaitInfo,
              {
                count: null,
                wating: null,
                skl_cd: arrSklCd[selIndex]
              },
              {
                name,
                width: "85%",
                height: "auto",
                styles: { "border-radius": "9px" }
              },
              { "before-close": this.closeWaitInfoEvent }
            );
          }
        } else {
          //미인증 사용자 일경우
          let params = {
            vdn_cd: arrVdnCd[selIndex],
            skl_cd: arrSklCd[selIndex],
            svcCode: this.$route.name
          };
          this.$Util.setStore("CONN_VDN_CD", arrVdnCd[selIndex]);
          this.$Util.setStore("CONN_SKL_CD", arrSklCd[selIndex]);
          this.$Util.setStore("CONN_SVC_CD", this.$route.name);
          this.$Util.setStore("CBT_PRT_YN", pgmObj.cbt_prt_yn);
          this.$Util.setStore("CHAT_SPRT_BIZ_YN", pgmObj.chat_sprt_biz_yn);

          this.$go("VARS00500", params);
        }
      }
    },
    closeWaitInfoEvent(event) {
      //상담사 대기 팝업 종료시 이벤트
      if (!this.$Util.isEmpty(event.params)) {
        //ivr 상담사 요청하기
        let sklCd = event.params;

        let userInfoParam = null;
        const isAuthzYn = this.$store.getters["customer/isAuthorize"];
        /*
        const connCustNo = this.$store.getters["customer/getConnInfo"](
          "custNo"
        );
        const connCustNm = this.$store.getters["customer/getConnInfo"](
          "custNm"
        );
        */
        const authUser = this.$store.getters["customer/getUser"]; // 본인 인증
        const selfConfirmInfo = this.$store.getters["customer/getSelfConfirmInfo"]; // 본인확인

        /*
        if (!isAuthzYn && !this.$Util.isEmpty(connCustNo)) {
          userInfoParam = {};
          userInfoParam.custNo = connCustNo;
          userInfoParam.custNm = connCustNm;
          userInfoParam.svcCode = this.$route.name;
        }
        */
        userInfoParam = {};
        userInfoParam.svcCode = this.$route.name;

        // 본인 인증이 최우선...
        if (isAuthzYn) {
          userInfoParam.custNo = authUser.custNo;
          userInfoParam.custNm = authUser.CustNm;
        } else if (selfConfirmInfo) {
          // 본인확인 이력이 있으면 최종 데이터는 본인확인 데이터
          userInfoParam.custNo = selfConfirmInfo.custNo;
          userInfoParam.custNm = selfConfirmInfo.CustNm;
        }
        
        this.reqIVR(
          "CON",
          sklCd,
          res => {
            //응답 콜백 - 이후 처리는 확인
            if (res.code == "000000") {
              this.closeService(true, { iscall: true });
            }
          },
          null,
          userInfoParam
        );
      }
    },
    clickBtnHome() {
      this.$go("VARS00101");
    },
    ...mapActions("manageUI", ["openMenu"])
  }
};
</script>
